import { render, staticRenderFns } from "./BaseItemSelector.vue?vue&type=template&id=357735a2&scoped=true"
import script from "./BaseItemSelector.vue?vue&type=script&lang=js"
export * from "./BaseItemSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseItemSelector.vue?vue&type=style&index=0&id=357735a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357735a2",
  null
  
)

export default component.exports